import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter, Link } from 'react-router-dom';
import { Popconfirm, Button } from 'antd';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as actions from '~actions/payment';
import * as authActions from '~actions/auth';
import LongtailPaymentSetupStatus from '~components/long-tail-payment-setup-status';
import LongtailInitialSetup from '~pages/payment/long-tail/setup/initial-setup';
import LongtailDeposit from '~pages/payment/long-tail/setup/deposit';
import EnablePaymentsSetup from '~pages/payment/long-tail/setup/enable-payments';
//import LongtailFee from '~pages/payment/long-tail/setup/fee';
import { fetch } from '~helpers/graphql';
import { formatSimpleParams } from '~helpers/params';
import * as landlordQueries from '~settings/queries';
import RentPayment from './rent-payment';
import generatePath from '~settings/routing';
import { bookingJourneyType, apCategory } from '~client/constants';
import { paymentPlanCategoryType } from '~constants';

const mapStateToProps = state => {
  const payment = state.payment.toJS();
  const auth = state.auth.toJS();
  return {
    paymentPlan: payment.longtail.paymentPlan,
    allowNoPayment: auth.base.allowNoPayment,
  };
};

const mapDispatchToProps = dispatch => ({
  getLandlordType: () => {
    dispatch(authActions.getLandlordType());
  },
  getPaymentPlan: (params, onSuccess) => {
    dispatch(actions.getLongtailPaymentPlan(params, onSuccess));
  },
  createPaymentPlan: (params, onSuccess) => {
    dispatch(actions.createLongtailPaymentPlan(params, onSuccess));
  },
  updatePaymentPlan: (params, onSuccess) => {
    dispatch(actions.updateLongtailPaymentPlan(params, onSuccess));
  },
  resetPaymentPlan: () => {
    dispatch(actions.resetLongtailPaymentPlan());
  },
  getList: (params, onSuccess) => {
    dispatch(actions.getLongtailPaymentPlansProperties(params, onSuccess));
  },
});

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
@withTranslation()
export default class LongtailPaymentSetup extends React.Component {
  constructor() {
    super();

    this.routingMapping = {
      'initial-setup': 'paymentInitialSetup',
      deposit: 'paymentDeposit',
      'rent-payment': 'paymentRentPayment',
      'enable-payments': 'paymentEnablePayments',
    };

    this.longtailInitialSetup = null;
    this.openEndDate = '9999-12-31';

    this.state = {
      disableBtn: false,
      isMustPayDespositFee: false,
      paymentplanCategory: 'RENT_IS_REQUIRED',
      hasKeyProperty: false,
      paymentOnline: true,
      properties: null,
    };
  }

  componentDidMount() {
    this.props.getLandlordType();
    const search = queryString.parse(this.props.location.search);
    this.getLandlordProperties();
    if (search && search.id) {
      this.props.getPaymentPlan({ id: search.id }, res => {
        if (res?.getPaymentPlan?.paymentPlan?.category) {
          this.setState({ paymentplanCategory: res.getPaymentPlan.paymentPlan.category });
        }
        if (
          this.state.hasKeyProperty &&
          res?.getPaymentPlan?.paymentPlan?.category === paymentPlanCategoryType.DEPOSIT_IS_REQUIRED
        ) {
          this.setState({ isMustPayDespositFee: true });
        }

        this.setState({ paymentOnline: res?.getPaymentPlan?.paymentPlan?.paymentOnline });

        const currentPageSlug = this.props.location.pathname.replace('/payment/setup/', '');
        this.props.history.push(
          generatePath(this.routingMapping[currentPageSlug], {}, { id: search.id }),
        );
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props?.location?.pathname !== nextProps?.location?.pathname &&
      nextProps.location?.pathname === '/payment/setup/initial-setup'
    ) {
      const search = queryString.parse(nextProps?.location?.search);
      if (search && search.id) {
        this.props.getPaymentPlan({ id: search.id });
      }
    }
  }

  componentWillUnmount() {
    this.props.resetPaymentPlan();
  }

  getPageByDirection = (redirectDirection = 'previous') => {
    const pathList = Object.keys(this.routingMapping);
    const currentPageSlug = this.props.location.pathname.replace('/payment/setup/', '');
    const currentPageIndex = pathList.indexOf(currentPageSlug);
    if (redirectDirection === 'previous') {
      if (currentPageIndex === 0) {
        return null;
      }
      return pathList[currentPageIndex - 1];
    }
    if (currentPageIndex === pathList.length - 1) {
      return null;
    }
    return pathList[currentPageIndex + 1];
  };

  handleCancelBtnClick = () => {
    this.props.history.push(generatePath('paymentList'));
  };

  handlePreviousBtnClick = () => {
    const targetUrl = this.getPageByDirection('previous');
    this.props.history.push(
      generatePath(
        this.routingMapping[targetUrl],
        {},
        {
          id: this.props?.paymentPlan?.id,
        },
      ),
    );
  };
  handleNextBtnClick = () => {
    this.setState({ disableBtn: true });
    const targetUrl = this.getPageByDirection('next');

    if (this.longtailInitialSetup) {
      this.handleInitialSetup(targetUrl);
    } else {
      this.props.history.push(
        generatePath(
          this.routingMapping[targetUrl],
          {},
          {
            id: this.props.paymentPlan.id,
          },
        ),
      );
      this.setState({ disableBtn: false });
    }
  };

  handleEnableBtnClick = () => {
    this.props.history.push(generatePath('paymentList'));
  };

  handleInitialSetup = targetUrl => {
    if (
      this.longtailInitialSetup &&
      this.longtailInitialSetup.props &&
      this.longtailInitialSetup.props.form
    ) {
      this.longtailInitialSetup.props.form.validateFields((err, value) => {
        if (!err) {
          if (this.longtailInitialSetup.props.form.isFieldsTouched()) {
            const {
              name,
              currency,

              description,
              paymentOnline,

              category,
            } = value;

            let payload = {
              name,
              currency,
              description,
              category,
              paymentOnline,
            };

            if (this.longtailInitialSetup.props.form.isFieldsTouched(['startDate'])) {
              payload.startDate = value.startDate.format('YYYY-MM-DD');
            }

            if (
              this.longtailInitialSetup.props.form.isFieldsTouched(['endDate']) ||
              this.longtailInitialSetup.props.form.isFieldsTouched(['openEnd'])
            ) {
              payload.endDate = value.openEnd
                ? this.openEndDate
                : value.endDate.format('YYYY-MM-DD');
            }

            if (!this.props.paymentPlan) {
              payload.properties =
                value.properties.map(property => ({ propertyId: property.id })) ?? [];

              this.props.createPaymentPlan(payload, res => {
                if (
                  res.createPaymentPlan.paymentPlan?.category ===
                  paymentPlanCategoryType.DEPOSIT_IS_REQUIRED
                ) {
                  this.setState({ isMustPayDespositFee: true });
                }
                this.setState({ paymentOnline: res.createPaymentPlan.paymentPlan.paymentOnline });
                this.props.history.push(
                  generatePath(
                    this.routingMapping[targetUrl],
                    {},
                    {
                      id: res.createPaymentPlan.paymentPlan.id,
                    },
                  ),
                );
              });
            } else {
              payload.properties =
                value.properties.map(property => ({
                  paymentPlanId: this.props.paymentPlan.id,
                  propertyId: property.id,
                })) ?? [];

              this.props.updatePaymentPlan({ ...payload, id: this.props.paymentPlan.id });
              this.props.history.push(
                generatePath(
                  this.routingMapping[targetUrl],
                  {},
                  {
                    id: this.props.paymentPlan.id,
                  },
                ),
              );
            }
          } else {
            this.props.history.push(
              generatePath(
                this.routingMapping[targetUrl],
                {},
                {
                  id: this.props.paymentPlan.id,
                },
              ),
            );
          }
        }
        this.setState({ disableBtn: false });
      });
    }
  };
  getLandlordProperties = () => {
    const propertiesType = [bookingJourneyType.INSTANT_BOOK, bookingJourneyType.SEMI_AUTOMATIC];
    fetch({
      query: landlordQueries.getLandLordSimpleProperties(
        formatSimpleParams(
          {
            bookingJourneys: null,
          },
          {
            bookingJourneys: propertiesType,
          },
        ),
      ),
    }).then(res => {
      if (res?.viewer?.properties?.edges?.length > 0) {
        let hasKeyProperty = res.viewer.properties.edges.some(
          item => item.node.apCategory === apCategory.KEY,
        );

        if (
          hasKeyProperty &&
          this.state.paymentplanCategory === paymentPlanCategoryType.DEPOSIT_IS_REQUIRED
        ) {
          this.setState({ isMustPayDespositFee: true });
        }
        this.setState({ hasKeyProperty, properties: res.viewer.properties.edges });
      }
    });
  };
  updatePaymentplanCategory = value => {
    this.setState({ paymentplanCategory: value });
  };
  render() {
    // If no id redirect to initial setup
    const search = queryString.parse(this.props.location.search);
    if (!this.props.location.pathname.includes('initial-setup') && (!search || !search.id)) {
      this.props.history.push(generatePath('paymentInitialSetup'));
    }

    const rentPaymentBtnDisabled =
      this.props.location.pathname.includes('rent-payment') &&
      !this.props.paymentPlan?.instalments?.length;

    const { isMustPayDespositFee, paymentplanCategory, hasKeyProperty, properties, paymentOnline } =
      this.state;

    const { deposits = [], fees = [] } = this.props.paymentPlan || {};
    const feeAndDeposit = deposits?.concat(fees);

    const depositFeeBtnDisabled =
      this.props.location.pathname.includes('deposit') &&
      isMustPayDespositFee &&
      !feeAndDeposit?.length;

    return (
      <div className="long-tail-setup">
        <Choose>
          <When condition={this.state.properties}>
            <div className="long-tail-setup__header">
              <p className="long-tail-setup__crumb">
                <Link to={generatePath('paymentList')}>
                  <span className="long-tail-setup__crumb-home">
                    {this.props.t('landlord.payment.long_tail.setup.crumb.home')}
                  </span>
                </Link>

                <span className="long-tail-setup__crumb-current">
                  {this.props.t(
                    `landlord.payment.long_tail.setup.crumb.${
                      search && search.id ? 'edit' : 'create'
                    }_current`,
                  )}
                </span>
              </p>
              <h2 className="long-tail-setup__header-title">
                {this.props.t(
                  `landlord.payment.long_tail.setup.${
                    search && search.id ? 'edit' : 'create'
                  }_title`,
                )}
              </h2>
            </div>
            <div className="long-tail-setup__layout">
              <div className="long-tail-setup__content-container">
                <LongtailPaymentSetupStatus
                  t={this.props.t}
                  currentStep={this.props.match.params.step}
                  push={this.props.history.push}
                  paymentPlan={this.props.paymentPlan}
                  handleInitialSetup={this.handleInitialSetup}
                />
                <Switch>
                  <Route
                    path="/payment/setup/initial-setup"
                    render={routeProps => (
                      <LongtailInitialSetup
                        {...routeProps}
                        t={this.props.t}
                        wrappedComponentRef={node => {
                          this.longtailInitialSetup = node;
                        }}
                        paymentPlan={this.props.paymentPlan}
                        getList={this.props.getList}
                        isEditPage={search && search.id}
                        paymentplanCategory={paymentplanCategory}
                        updatePaymentplanCategory={this.updatePaymentplanCategory}
                        hasKeyProperty={hasKeyProperty}
                        properties={properties}
                        allowNoPayment={this.props.allowNoPayment}
                        paymentOnline={paymentOnline}
                        setPaymentOnline={value => {
                          this.setState({ paymentOnline: value });
                        }}
                      />
                    )}
                  />
                  <Route
                    path="/payment/setup/deposit"
                    render={routeProps => (
                      <LongtailDeposit
                        {...routeProps}
                        paymentPlan={this.props.paymentPlan}
                        getPaymentPlan={this.props.getPaymentPlan}
                        isMustPayDespositFee={isMustPayDespositFee}
                        paymentOnline={paymentOnline}
                      />
                    )}
                  />
                  <Route
                    path="/payment/setup/enable-payments"
                    render={routeProps => (
                      <EnablePaymentsSetup
                        {...routeProps}
                        hasKeyProperty={hasKeyProperty}
                        paymentplanCategory={paymentplanCategory}
                        paymentOnline={paymentOnline}
                      />
                    )}
                  />
                  {/* <Route
                    path="/payment/setup/fee"
                    render={routeProps => (
                      <LongtailFee
                        {...routeProps}
                        paymentPlan={this.props.paymentPlan}
                        getPaymentPlan={this.props.getPaymentPlan}
                      />
                    )}
                  /> */}
                  <Route
                    path="/payment/setup/rent-payment"
                    render={routeProps => (
                      <RentPayment
                        {...routeProps}
                        paymentPlan={this.props.paymentPlan}
                        getPaymentPlan={this.props.getPaymentPlan}
                        isMustPayDespositFee={isMustPayDespositFee}
                        properties={properties}
                        paymentOnline={paymentOnline}
                      />
                    )}
                  />
                </Switch>
              </div>
              <div className="long-tail-setup__footer">
                <If condition={this.getPageByDirection('previous')}>
                  <button
                    className="long-tail-setup__btn long-tail-setup__btn--previous"
                    onClick={this.handlePreviousBtnClick}
                  >
                    {this.props.t('landlord.payment.long_tail.setup.btn.previous')}
                  </button>
                </If>
                <If condition={!this.getPageByDirection('previous')}>
                  <Popconfirm
                    okText="Confirm"
                    cancelText="Cancel"
                    onConfirm={this.handleEnableBtnClick}
                    placement="topLeft"
                    overlayStyle={{
                      maxWidth: '300px',
                    }}
                    title="Do you confirm to cancel the changes? All the changes will not take effect if you confirm to cancel."
                  >
                    <button className="long-tail-setup__btn long-tail-setup__btn--cancel">
                      {this.props.t('landlord.payment.long_tail.setup.btn.cancel')}
                    </button>
                  </Popconfirm>
                </If>

                <If condition={this.getPageByDirection('next')}>
                  <Button
                    type="primary"
                    className="long-tail-setup__btn long-tail-setup__btn--next"
                    onClick={this.handleNextBtnClick}
                    disabled={
                      this.state.disableBtn || rentPaymentBtnDisabled || depositFeeBtnDisabled
                    }
                  >
                    {this.props.t('landlord.payment.long_tail.setup.btn.next')}
                  </Button>
                </If>
                <If condition={!this.getPageByDirection('next')}>
                  <Button
                    type="primary"
                    className="long-tail-setup__btn long-tail-setup__btn--confirm"
                    onClick={this.handleEnableBtnClick}
                    disabled={this.state.disableBtn || rentPaymentBtnDisabled}
                  >
                    {this.props.t('landlord.payment.long_tail.setup.btn.enable_payment')}
                  </Button>
                </If>
              </div>
            </div>
          </When>
          <Otherwise>
            <div className="long-tail-setup__content">
              <span className="loading" style={{ top: '100px' }} />
            </div>
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

LongtailPaymentSetup.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      step: PropTypes.string,
    }),
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  t: PropTypes.func.isRequired,
  paymentPlan: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  createPaymentPlan: PropTypes.func,
  updatePaymentPlan: PropTypes.func,
  getPaymentPlan: PropTypes.func,
  resetPaymentPlan: PropTypes.func,
  getList: PropTypes.func,
};

LongtailPaymentSetup.defaultProps = {
  match: {
    params: {
      step: '',
    },
  },
  history: {
    push: () => {},
  },
  t: () => {},
  createPaymentPlan: () => {},
  updatePaymentPlan: () => {},
  getPaymentPlan: () => {},
  resetPaymentPlan: () => {},
  getList: () => {},
  paymentPlan: null,
};
